import { render, staticRenderFns } from "./Pfv.vue?vue&type=template&id=05c92195&scoped=true&"
import script from "./Pfv.vue?vue&type=script&lang=js&"
export * from "./Pfv.vue?vue&type=script&lang=js&"
import style0 from "./Pfv.vue?vue&type=style&index=0&id=05c92195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c92195",
  null
  
)

export default component.exports